// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vertical-align-middle {
  vertical-align: middle;
}

.fi-profile-icon {
  display: inline-block;
  position: relative;
}
.fi-profile-icon .fi-profile-icon-img,
.fi-profile-icon .fi-profile-colored {
  border-radius: 10px;
  vertical-align: baseline;
}
.fi-profile-icon.rounded .fi-profile-icon-img,
.fi-profile-icon.rounded .fi-profile-colored {
  border-radius: 50%;
}
.fi-profile-icon .fi-profile-icon-icon {
  color: var(--fi-color-light);
}
.fi-profile-icon .fi-profile-icon-icon::before {
  line-height: 1;
  display: block;
  transform: translateZ(0);
}
.fi-profile-icon .fi-profile-colored {
  text-align: center;
  color: var(--fi-color-white);
}
.fi-profile-icon.size-Size14px {
  width: 14px;
  height: 14px;
  min-width: 14px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
}
.fi-profile-icon.size-Size14px .mat-icon,
.fi-profile-icon.size-Size14px .fi-profile-colored,
.fi-profile-icon.size-Size14px .default-icon {
  width: 14px;
  height: 14px;
}
.fi-profile-icon.size-Size14px .fi-profile-colored {
  line-height: 14px;
}
.fi-profile-icon.size-Size14px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size14px .fi-profile-icon-img {
  width: 14px;
  height: 14px;
  margin: auto;
}
.fi-profile-icon.size-Size14px .fi-profile-colored {
  font-size: 8px;
  width: 14px;
  height: 14px;
  line-height: 14px;
}
.fi-profile-icon.size-Size14px .mat-icon {
  height: unset;
}
.fi-profile-icon.size-Size18px {
  width: 18px;
  height: 18px;
  min-width: 18px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
  line-height: 19px;
}
.fi-profile-icon.size-Size18px .mat-icon,
.fi-profile-icon.size-Size18px .fi-profile-colored,
.fi-profile-icon.size-Size18px .default-icon {
  width: 18px;
  height: 18px;
}
.fi-profile-icon.size-Size18px .fi-profile-colored {
  line-height: 18px;
}
.fi-profile-icon.size-Size18px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size18px .fi-profile-icon-img {
  vertical-align: middle;
}
.fi-profile-icon.size-Size18px .fi-profile-icon-icon {
  font-size: 18px;
}
.fi-profile-icon.size-Size18px .fi-profile-icon-icon.mat-icon {
  display: inline-block;
  line-height: 19px;
  overflow: visible !important;
}
.fi-profile-icon.size-Size18px .fi-profile-icon-icon.mat-icon::before {
  width: 18px;
  height: 18px;
  display: block;
}
.fi-profile-icon.size-Size18px .fi-profile-colored {
  font-size: 10px;
  width: 18px;
  height: 18px;
  line-height: 19px;
}
.fi-profile-icon.size-Size20px {
  width: 20px;
  height: 20px;
  min-width: 20px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
}
.fi-profile-icon.size-Size20px .mat-icon,
.fi-profile-icon.size-Size20px .fi-profile-colored,
.fi-profile-icon.size-Size20px .default-icon {
  width: 20px;
  height: 20px;
}
.fi-profile-icon.size-Size20px .fi-profile-colored {
  line-height: 20px;
}
.fi-profile-icon.size-Size20px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size20px .fi-online-badge {
  display: none;
}
.fi-profile-icon.size-Size18px .fi-online-badge, .fi-profile-icon.size-Size24px .fi-online-badge, .fi-profile-icon.size-Size28px .fi-online-badge {
  width: 8px;
  height: 8px;
  bottom: 0;
  right: 0;
  border-width: 1px;
}
.fi-profile-icon.size-Size24px {
  width: 24px;
  height: 24px;
  min-width: 24px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
}
.fi-profile-icon.size-Size24px .mat-icon,
.fi-profile-icon.size-Size24px .fi-profile-colored,
.fi-profile-icon.size-Size24px .default-icon {
  width: 24px;
  height: 24px;
}
.fi-profile-icon.size-Size24px .fi-profile-colored {
  line-height: 24px;
}
.fi-profile-icon.size-Size24px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size24px .fi-profile-icon-icon {
  font-size: 1.3em;
}
.fi-profile-icon.size-Size24px .fi-profile-colored {
  font-size: 12px;
}
.fi-profile-icon.size-Size28px {
  width: 28px;
  height: 28px;
  min-width: 28px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
  line-height: 28px;
}
.fi-profile-icon.size-Size28px .mat-icon,
.fi-profile-icon.size-Size28px .fi-profile-colored,
.fi-profile-icon.size-Size28px .default-icon {
  width: 28px;
  height: 28px;
}
.fi-profile-icon.size-Size28px .fi-profile-colored {
  line-height: 28px;
}
.fi-profile-icon.size-Size28px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size28px .fi-profile-icon-icon {
  font-size: 1.3em;
}
.fi-profile-icon.size-Size28px .fi-profile-icon-icon.mat-icon {
  font-size: 28px;
  display: inline-block;
  line-height: 28px;
  overflow: visible !important;
}
.fi-profile-icon.size-Size28px .fi-profile-icon-icon.mat-icon::before {
  width: 28px;
  height: 28px;
  display: block;
}
.fi-profile-icon.size-Size28px .fi-profile-colored {
  font-size: 14px;
}
.fi-profile-icon.size-Size32px {
  width: 32px;
  height: 32px;
  min-width: 32px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
  line-height: 32px;
}
.fi-profile-icon.size-Size32px .mat-icon,
.fi-profile-icon.size-Size32px .fi-profile-colored,
.fi-profile-icon.size-Size32px .default-icon {
  width: 32px;
  height: 32px;
}
.fi-profile-icon.size-Size32px .fi-profile-colored {
  line-height: 32px;
}
.fi-profile-icon.size-Size32px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size32px .fi-profile-icon-icon {
  font-size: 32px;
}
.fi-profile-icon.size-Size32px .fi-profile-icon-icon.mat-icon {
  display: inline-block;
  line-height: 32px;
  overflow: visible !important;
}
.fi-profile-icon.size-Size32px .fi-profile-icon-icon.mat-icon::before {
  width: 32px;
  height: 32px;
  display: block;
}
.fi-profile-icon.size-Size32px .fi-online-badge {
  width: 10px;
  height: 10px;
  bottom: 0;
  right: 0;
}
.fi-profile-icon.size-Size40px {
  width: 40px;
  height: 40px;
  min-width: 40px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
}
.fi-profile-icon.size-Size40px .mat-icon,
.fi-profile-icon.size-Size40px .fi-profile-colored,
.fi-profile-icon.size-Size40px .default-icon {
  width: 40px;
  height: 40px;
}
.fi-profile-icon.size-Size40px .fi-profile-colored {
  line-height: 40px;
}
.fi-profile-icon.size-Size40px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size40px .fi-online-badge {
  width: 12px;
  height: 12px;
  bottom: 0;
  right: 0;
}
.fi-profile-icon.size-Size40px .fi-profile-icon-icon.mat-icon {
  font-size: 40px;
  display: inline-block;
  line-height: 40px;
  overflow: visible !important;
  text-align: center;
  transform: translateX(1px);
}
.fi-profile-icon.size-Size50px {
  width: 50px;
  height: 50px;
  min-width: 50px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
}
.fi-profile-icon.size-Size50px .mat-icon,
.fi-profile-icon.size-Size50px .fi-profile-colored,
.fi-profile-icon.size-Size50px .default-icon {
  width: 50px;
  height: 50px;
}
.fi-profile-icon.size-Size50px .fi-profile-colored {
  line-height: 50px;
}
.fi-profile-icon.size-Size50px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size50px .fi-profile-icon-icon {
  font-size: 3.2em;
}
.fi-profile-icon.size-Size50px .fi-online-badge {
  bottom: 2px;
  right: 0;
  width: 15px;
  height: 15px;
}
.fi-profile-icon.size-Size64px {
  width: 64px;
  height: 64px;
  min-width: 64px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
}
.fi-profile-icon.size-Size64px .mat-icon,
.fi-profile-icon.size-Size64px .fi-profile-colored,
.fi-profile-icon.size-Size64px .default-icon {
  width: 64px;
  height: 64px;
}
.fi-profile-icon.size-Size64px .fi-profile-colored {
  line-height: 64px;
}
.fi-profile-icon.size-Size64px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size64px .fi-profile-icon-icon {
  font-size: 64px;
}
.fi-profile-icon.size-Size64px .fi-profile-colored {
  font-size: 32px;
}
.fi-profile-icon.size-Size64px .fi-online-badge {
  bottom: 2px;
  right: 0;
  width: 15px;
  height: 15px;
}
.fi-profile-icon.size-Size150px {
  width: 150px;
  height: 150px;
  min-width: 150px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
  font-size: 5.2em;
}
.fi-profile-icon.size-Size150px .mat-icon,
.fi-profile-icon.size-Size150px .fi-profile-colored,
.fi-profile-icon.size-Size150px .default-icon {
  width: 150px;
  height: 150px;
}
.fi-profile-icon.size-Size150px .fi-profile-colored {
  line-height: 150px;
}
.fi-profile-icon.size-Size150px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size150px .fi-online-badge {
  bottom: 5px;
  right: 25px;
  width: 16px;
  height: 16px;
}
.fi-profile-icon.size-Size130px {
  width: 130px;
  height: 130px;
  min-width: 130px;
  /*  .fi-profile-icon-icon {
    font-size: \$size;
  }*/
  font-size: 4.2em;
}
.fi-profile-icon.size-Size130px .mat-icon,
.fi-profile-icon.size-Size130px .fi-profile-colored,
.fi-profile-icon.size-Size130px .default-icon {
  width: 130px;
  height: 130px;
}
.fi-profile-icon.size-Size130px .fi-profile-colored {
  line-height: 130px;
}
.fi-profile-icon.size-Size130px .fi-profile-icon-img {
  box-shadow: 0 0 0 1px var(--fi-border-color-light);
  min-width: 100%;
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.fi-profile-icon.size-Size130px .fi-online-badge {
  bottom: 0px;
  right: 25px;
  width: 16px;
  height: 16px;
}
.fi-profile-icon .fi-online-badge {
  background-color: var(--fi-color-green);
  border: 2px solid var(--fi-color-white);
  position: absolute;
  border-radius: 50%;
}

.mat-mdc-option .mdc-list-item__primary-text .fi-profile-icon.size-Size32px .fi-profile-icon-icon {
  font-size: 28px;
}`, "",{"version":3,"sources":["webpack://./Source/Content/CSS/_variables.scss","webpack://./Source/app/shared/profile-icon/profile-icon.component.scss"],"names":[],"mappings":"AAkaA;EACI,sBAAA;ACjaJ;;AA6BA;EACI,qBAAA;EACA,kBAAA;AA1BJ;AA4BI;;EAEI,mBAAA;EACA,wBAAA;AA1BR;AA8BQ;;EAEI,kBAAA;AA5BZ;AAgCI;EACI,4BAAA;AA9BR;AA+BQ;EACI,cAAA;EACA,cAAA;EACA,wBAAA;AA7BZ;AAiCI;EACI,kBAAA;EACA,4BAAA;AA/BR;AAkCI;EA3DA,WA4DmB;EA3DnB,YA2DmB;EA1DnB,eA0DmB;EAxDnB;;IAAA;AA6BJ;AAzBI;;;EAGI,WAiDe;EAhDf,YAgDe;AArBvB;AAxBI;EACI,iBA4Ce;AAlBvB;AAvBI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAyBR;AAYQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;AAVZ;AAYQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAVZ;AAYQ;EACI,aAAA;AAVZ;AAcI;EA7EA,WA8EmB;EA7EnB,YA6EmB;EA5EnB,eA4EmB;EA1EnB;;IAAA;EA2EI,iBAAA;AAPR;AAhEI;;;EAGI,WAmEe;EAlEf,YAkEe;AAAvB;AA/DI;EACI,iBA8De;AAGvB;AA9DI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAgER;AAPQ;EACI,sBAAA;AASZ;AAPQ;EACI,eAAA;AASZ;AARY;EACI,qBAAA;EACA,iBAAA;EACA,4BAAA;AAUhB;AATgB;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAWpB;AAPQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AASZ;AALI;EAzGA,WA0GmB;EAzGnB,YAyGmB;EAxGnB,eAwGmB;EAtGnB;;IAAA;AAkHJ;AA9GI;;;EAGI,WA+Fe;EA9Ff,YA8Fe;AAkBvB;AA7GI;EACI,iBA0Fe;AAqBvB;AA5GI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AA8GR;AA3BQ;EACI,aAAA;AA6BZ;AAtBQ;EACI,UAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;AAwBZ;AApBI;EA5HA,WA6HmB;EA5HnB,YA4HmB;EA3HnB,eA2HmB;EAzHnB;;IAAA;AAoJJ;AAhJI;;;EAGI,WAkHe;EAjHf,YAiHe;AAiCvB;AA/II;EACI,iBA6Ge;AAoCvB;AA9II;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAgJR;AA1CQ;EACI,gBAAA;AA4CZ;AA1CQ;EACI,eAAA;AA4CZ;AAzCI;EArIA,WAsImB;EArInB,YAqImB;EApInB,eAoImB;EAlInB;;IAAA;EAmII,iBAAA;AAgDR;AA/KI;;;EAGI,WA2He;EA1Hf,YA0He;AAuDvB;AA9KI;EACI,iBAsHe;AA0DvB;AA7KI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AA+KR;AA/DQ;EACI,gBAAA;AAiEZ;AAhEY;EACI,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,4BAAA;AAkEhB;AAjEgB;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAmEpB;AA/DQ;EACI,eAAA;AAiEZ;AA7DI;EA3JA,WA4JmB;EA3JnB,YA2JmB;EA1JnB,eA0JmB;EAxJnB;;IAAA;EAyJI,iBAAA;AAoER;AAzNI;;;EAGI,WAiJe;EAhJf,YAgJe;AA2EvB;AAxNI;EACI,iBA4Ie;AA8EvB;AAvNI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAyNR;AAnFQ;EACI,eAAA;AAqFZ;AApFY;EACI,qBAAA;EACA,iBAAA;EACA,4BAAA;AAsFhB;AArFgB;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAuFpB;AAlFQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AAoFZ;AAhFI;EApLA,WAqLmB;EApLnB,YAoLmB;EAnLnB,eAmLmB;EAjLnB;;IAAA;AAwQJ;AApQI;;;EAGI,WA0Ke;EAzKf,YAyKe;AA6FvB;AAnQI;EACI,iBAqKe;AAgGvB;AAlQI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAoQR;AArGQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AAuGZ;AApGY;EACI,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,0BAAA;AAsGhB;AAjGI;EAzMA,WA0MmB;EAzMnB,YAyMmB;EAxMnB,eAwMmB;EAtMnB;;IAAA;AA8SJ;AA1SI;;;EAGI,WA+Le;EA9Lf,YA8Le;AA8GvB;AAzSI;EACI,iBA0Le;AAiHvB;AAxSI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AA0SR;AAvHQ;EACI,gBAAA;AAyHZ;AAtHQ;EACI,WAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AAwHZ;AApHI;EAvNA,WAwNmB;EAvNnB,YAuNmB;EAtNnB,eAsNmB;EApNnB;;IAAA;AA+UJ;AA3UI;;;EAGI,WA6Me;EA5Mf,YA4Me;AAiIvB;AA1UI;EACI,iBAwMe;AAoIvB;AAzUI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AA2UR;AA1IQ;EACI,eAAA;AA4IZ;AA1IQ;EACI,eAAA;AA4IZ;AA1IQ;EACI,WAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AA4IZ;AAxII;EAvOA,YAwOmB;EAvOnB,aAuOmB;EAtOnB,gBAsOmB;EApOnB;;IAAA;EAqOI,gBAAA;AA+IR;AAhXI;;;EAGI,YA6Ne;EA5Nf,aA4Ne;AAsJvB;AA/WI;EACI,kBAwNe;AAyJvB;AA9WI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAgXR;AA7JQ;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AA+JZ;AA3JI;EAnPA,YAoPmB;EAnPnB,aAmPmB;EAlPnB,gBAkPmB;EAhPnB;;IAAA;EAiPI,gBAAA;AAkKR;AA/YI;;;EAGI,YAyOe;EAxOf,aAwOe;AAyKvB;AA9YI;EACI,kBAoOe;AA4KvB;AA7YI;EACI,kDAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AA+YR;AAhLQ;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAkLZ;AA9KI;EACI,uCAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;AAgLR;;AAzKY;EACI,eAAA;AA4KhB","sourcesContent":["@use 'sass:color';\r\n$DefaultFontFamily: Roboto, 'Noto Sans', Arial;\r\n$DefaultFontSize: 14px;\r\n\r\n$MinWidthIphone5: 320px;\r\n$MaxWidthIphone5: 568px;\r\n$MinWidthIphone6: 375px;\r\n$MaxWidthIphone6: 667px;\r\n\r\n$BreakMobile: 768px;\r\n$BreakMobileSmall: 450px;\r\n$BreakPadPortrait: 1024px;\r\n$BreakPadLandscape: 1280px;\r\n$BreakMobileMat: 599px;\r\n\r\n// note: the same values used in JS\r\n$checklistStatusColor1: #b8b8b8;\r\n$checklistStatusColor2: #5aaf4b;\r\n$checklistStatusColor3: #cbe6c8;\r\n$checklistStatusColor4: #f44336;\r\n$checklistStatusColorOk: #ffecb3;\r\n$checklistStatusColorDeviation: #ffc107;\r\n$dndOverlayBackgroundColor: #ffffff;\r\n$dndOverlayIconColorRed: #ee3636;\r\n$dndOverlayIconColorOrange: #ff7700;\r\n$dndOverlayIconColorBlue: #366fd2;\r\n\r\n$checklistStatusColorLightOpacity: 0.6;\r\n$dndOverlayBackgroundOpacity: 0.15;\r\n\r\n$checklistStatusColor1Light: color.adjust($checklistStatusColor1, $alpha: -$checklistStatusColorLightOpacity);\r\n$checklistStatusColor2Light: color.adjust($checklistStatusColor2, $alpha: -$checklistStatusColorLightOpacity);\r\n$checklistStatusColor3Light: color.adjust($checklistStatusColor3, $alpha: -$checklistStatusColorLightOpacity);\r\n$checklistStatusColor4Light: color.adjust($checklistStatusColor4, $alpha: -$checklistStatusColorLightOpacity);\r\n$checklistStatusColorOkLight: color.adjust($checklistStatusColorOk, $alpha: -$checklistStatusColorLightOpacity);\r\n$checklistStatusColorDeviationLight: color.adjust(\r\n    $checklistStatusColorDeviation,\r\n    $alpha: -$checklistStatusColorLightOpacity\r\n);\r\n$dndOverlayBackgroundColorWhiteTransparent: color.adjust(\r\n    $dndOverlayBackgroundColor,\r\n    $alpha: -$dndOverlayBackgroundOpacity\r\n);\r\n\r\n$siteMapHeadersColor: #757575;\r\n\r\n// todo: remove\r\n$BreakMobileMin: $BreakMobileSmall + 1px;\r\n\r\n// remove this variable (min-width break some things, remove min-width completely or change max-with on min-width rules)\r\n$BreakPadPortraitMin: $BreakMobile + 1px;\r\n\r\n$FormRowMargin: 14px;\r\n\r\n@mixin box-sizing($box: border-box) {\r\n    -webkit-box-sizing: $box;\r\n    -moz-box-sizing: $box;\r\n    box-sizing: $box;\r\n}\r\n\r\n@mixin box-shadow($properties: inset 0 0px 0px rgba(0, 0, 0, 0.075)) {\r\n    -webkit-box-shadow: $properties;\r\n    -moz-box-shadow: $properties;\r\n    box-shadow: $properties;\r\n}\r\n\r\n@mixin box-shadow-gray-light($lightness: 0, $opacity: 0.75) {\r\n    @include box-shadow(0 0 5px 0 rgba($lightness, $lightness, $lightness, $opacity));\r\n}\r\n\r\n@mixin center-height($height: 24px) {\r\n    height: $height;\r\n    line-height: $height;\r\n}\r\n\r\n@mixin center-min-height($height: 24px) {\r\n    min-height: $height;\r\n    line-height: $height;\r\n}\r\n\r\n@mixin square($dimensions) {\r\n    width: $dimensions;\r\n    height: $dimensions;\r\n}\r\n\r\n@mixin square-max($dimensions) {\r\n    max-width: $dimensions;\r\n    max-height: $dimensions;\r\n}\r\n\r\n// todo: remove\r\n@mixin transform($transform) {\r\n    -webkit-transform: $transform;\r\n    -moz-transform: $transform;\r\n    -o-transform: $transform;\r\n    -ms-transform: $transform;\r\n    transform: $transform;\r\n}\r\n\r\n@mixin flex() {\r\n    display: -webkit-box;\r\n    display: -moz-box;\r\n    display: -ms-flexbox;\r\n    display: -webkit-flex;\r\n    display: flex;\r\n}\r\n\r\n@mixin flex-inline() {\r\n    display: -webkit-inline-flex;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n}\r\n\r\n@mixin flex_important() {\r\n    display: -webkit-box !important;\r\n    display: -moz-box !important;\r\n    display: -ms-flexbox !important;\r\n    display: -webkit-flex !important;\r\n    display: flex !important;\r\n}\r\n\r\n@mixin flex-style($flex-value: 1) {\r\n    -webkit-box-flex: $flex-value;\r\n    -moz-box-flex: $flex-value;\r\n    -webkit-flex: $flex-value;\r\n    -ms-flex: $flex-value;\r\n    flex: $flex-value;\r\n}\r\n\r\n@mixin flex-direction($direction: row) {\r\n    -webkit-flex-direction: $direction;\r\n    flex-direction: $direction;\r\n}\r\n\r\n@mixin flex-wrap($wrap: wrap) {\r\n    -webkit-flex-wrap: $wrap;\r\n    flex-wrap: $wrap;\r\n}\r\n\r\n@mixin flex-grow($number) {\r\n    -webkit-flex-grow: $number;\r\n    flex-grow: $number;\r\n}\r\n\r\n@mixin flex-shrink($number) {\r\n    -webkit-flex-shrink: $number;\r\n    flex-shrink: $number;\r\n}\r\n\r\n@mixin flex-flow($flow) {\r\n    -webkit-flex-flow: $flow;\r\n    flex-flow: $flow;\r\n}\r\n\r\n@mixin flex-align($align) {\r\n    -webkit-box-align: $align;\r\n    -moz-box-align: $align;\r\n    -ms-flex-align: $align;\r\n    -webkit-align-items: $align;\r\n    align-items: $align;\r\n}\r\n\r\n@mixin flex-justify-content($justify) {\r\n    -webkit-box-pack: $justify;\r\n    -moz-box-pack: $justify;\r\n    -ms-flex-pack: $justify;\r\n    -webkit-justify-content: $justify;\r\n    justify-content: $justify;\r\n}\r\n\r\n@mixin flex-basis($basis) {\r\n    -webkit-flex-basis: $basis;\r\n    flex-basis: $basis;\r\n}\r\n\r\n@mixin user-select($select: none) {\r\n    -webkit-touch-callout: $select;\r\n    -webkit-user-select: $select;\r\n    -khtml-user-select: $select;\r\n    -moz-user-select: $select;\r\n    -ms-user-select: $select;\r\n    user-select: $select;\r\n}\r\n\r\n@mixin animation-delay($delay: 0s) {\r\n    -moz-animation-delay: $delay;\r\n    -webkit-animation-delay: $delay;\r\n    -ms-animation-delay: $delay;\r\n    -o-animation-delay: $delay;\r\n    animation-delay: $delay;\r\n}\r\n\r\n@mixin one-line-text() {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n@mixin transform-scale($scale) {\r\n    -moz-transform: scale($scale);\r\n    -webkit-transform: scale($scale);\r\n    -ms-transform: scale($scale);\r\n    -o-transform: scale($scale);\r\n    transform: scale($scale);\r\n}\r\n\r\n@mixin transform-translateZ($translateZ) {\r\n    -webkit-transform: translateZ($translateZ);\r\n    -moz-transform: translateZ($translateZ);\r\n    -o-transform: translateZ($translateZ);\r\n    transform: translateZ($translateZ);\r\n}\r\n\r\n// todo: remove radius. supported by all browsers\r\n@mixin radius-left($radius) {\r\n    -webkit-border-bottom-left-radius: $radius;\r\n    -moz-border-radius-bottomleft: $radius;\r\n    border-bottom-left-radius: $radius;\r\n    -webkit-border-top-left-radius: $radius;\r\n    -moz-border-radius-topleft: $radius;\r\n    border-top-left-radius: $radius;\r\n}\r\n\r\n@mixin radius-right($radius) {\r\n    -webkit-border-bottom-right-radius: $radius;\r\n    -moz-border-radius-bottomright: $radius;\r\n    border-bottom-right-radius: $radius;\r\n    -webkit-border-top-right-radius: $radius;\r\n    -moz-border-radius-topright: $radius;\r\n    border-top-right-radius: $radius;\r\n}\r\n\r\n@mixin radius-top($radius) {\r\n    -webkit-border-top-left-radius: $radius;\r\n    -moz-border-radius-topleft: $radius;\r\n    border-top-left-radius: $radius;\r\n    -webkit-border-top-right-radius: $radius;\r\n    -moz-border-radius-topright: $radius;\r\n    border-top-right-radius: $radius;\r\n}\r\n\r\n@mixin radius-bottom($radius) {\r\n    -webkit-border-bottom-left-radius: $radius;\r\n    -moz-border-radius-bottomleft: $radius;\r\n    border-bottom-left-radius: $radius;\r\n    -webkit-border-bottom-right-radius: $radius;\r\n    -moz-border-radius-bottomright: $radius;\r\n    border-bottom-right-radius: $radius;\r\n}\r\n\r\n@mixin radius($radius) {\r\n    -webkit-border-radius: $radius;\r\n    -moz-border-radius: $radius;\r\n    border-radius: $radius;\r\n}\r\n\r\n@mixin background-size($size) {\r\n    -webkit-background-size: $size;\r\n    -moz-background-size: $size;\r\n    -o-background-size: $size;\r\n    background-size: $size;\r\n}\r\n\r\n@mixin rotate($value) {\r\n    -webkit-transform: rotate($value);\r\n    transform: rotate($value);\r\n}\r\n\r\n@mixin fi-card-shadow {\r\n    box-shadow:\r\n        0 1px 3px 0 rgba(0, 0, 0, 0.2),\r\n        0 1px 1px 0 rgba(0, 0, 0, 0.14),\r\n        0 2px 1px -1px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n@mixin fi-card-shadow-2x {\r\n    box-shadow:\r\n        0 2px 6px 0 rgba(0, 0, 0, 0.2),\r\n        0 2px 2px 0 rgba(0, 0, 0, 0.14),\r\n        0 4px 2px -2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n@mixin fi-container-horizontal() {\r\n    width: 100%;\r\n    overflow: auto;\r\n\r\n    @include flex();\r\n    @include flex-direction(row);\r\n\r\n    > .fi-content {\r\n        @include flex-style(1);\r\n        width: 100%;\r\n        overflow: auto;\r\n        position: relative;\r\n    }\r\n}\r\n\r\n@mixin cursor-grab() {\r\n    cursor: move;\r\n    cursor: -webkit-grab;\r\n    cursor: -moz-grab;\r\n    cursor: grab;\r\n}\r\n\r\n@mixin cursor-grab-vertical() {\r\n    cursor: ns-resize;\r\n    cursor: -webkit-grab;\r\n    cursor: -moz-grab;\r\n    cursor: grab;\r\n}\r\n\r\n@mixin width-min-max($width) {\r\n    width: $width;\r\n    min-width: $width;\r\n    max-width: $width;\r\n}\r\n\r\n@mixin break-portrait() {\r\n    @media (max-width: $BreakPadPortrait) {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin break-landscape() {\r\n    @media (max-width: $BreakPadLandscape) {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin break-mobile() {\r\n    @media (max-width: $BreakMobile) {\r\n        @content;\r\n    }\r\n\r\n    .fi-device-size-break-mobile {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin break-mobile-small() {\r\n    @media (max-width: $BreakMobileSmall) {\r\n        @content;\r\n    }\r\n\r\n    .fi-device-size-break-mobile-small {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin break-mobile-small-no-transition {\r\n    @include break-mobile-small {\r\n        transition: none;\r\n    }\r\n}\r\n\r\n@mixin break-mobile-mat() {\r\n    @media (max-width: $BreakMobileMat) {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin clearfix {\r\n    &:before,\r\n    &:after {\r\n        display: table;\r\n        content: ' ';\r\n    }\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n}\r\n\r\n@mixin mobile-top-area-icon($left-offset) {\r\n    line-height: 1;\r\n    position: absolute;\r\n    top: 4px;\r\n\r\n    .fi-btn-icon {\r\n        padding: 10px;\r\n        .icon {\r\n            @include radius(50%);\r\n            width: 20px;\r\n            height: 20px;\r\n            display: block;\r\n\r\n            img {\r\n                width: 20px;\r\n                height: 20px;\r\n            }\r\n            .icon {\r\n                font-size: 20px !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    .notifications-count {\r\n        top: 4px;\r\n        left: $left-offset;\r\n    }\r\n}\r\n\r\n@mixin notifications-count {\r\n    padding: 2px 5px;\r\n    @include radius(10px);\r\n    position: absolute;\r\n    line-height: 1em;\r\n    font-weight: bold;\r\n    font-size: 0.8em;\r\n    z-index: 1;\r\n}\r\n\r\n@mixin flex-column-gap($gap) {\r\n    @include flex();\r\n    @include flex-direction(column);\r\n    gap: $gap;\r\n}\r\n\r\n.vertical-align-middle {\r\n    vertical-align: middle;\r\n}\r\n","@use '../../../Content/CSS/variables';\r\n\r\n@mixin sized($size) {\r\n    width: $size;\r\n    height: $size;\r\n    min-width: $size;\r\n\r\n    /*  .fi-profile-icon-icon {\r\n    font-size: $size;\r\n  }*/\r\n\r\n    .mat-icon,\r\n    .fi-profile-colored,\r\n    .default-icon {\r\n        width: $size;\r\n        height: $size;\r\n    }\r\n\r\n    .fi-profile-colored {\r\n        line-height: $size;\r\n    }\r\n\r\n    .fi-profile-icon-img {\r\n        box-shadow: 0 0 0 1px var(--fi-border-color-light);\r\n        min-width: 100%;\r\n        width: 100%;\r\n        min-height: 100%;\r\n        height: 100%;\r\n    }\r\n}\r\n\r\n.fi-profile-icon {\r\n    display: inline-block;\r\n    position: relative;\r\n\r\n    .fi-profile-icon-img,\r\n    .fi-profile-colored {\r\n        border-radius: 10px;\r\n        vertical-align: baseline;\r\n    }\r\n\r\n    &.rounded {\r\n        .fi-profile-icon-img,\r\n        .fi-profile-colored {\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n\r\n    .fi-profile-icon-icon {\r\n        color: var(--fi-color-light);\r\n        &::before {\r\n            line-height: 1;\r\n            display: block;\r\n            transform: translateZ(0);\r\n        }\r\n    }\r\n\r\n    .fi-profile-colored {\r\n        text-align: center;\r\n        color: var(--fi-color-white);\r\n    }\r\n\r\n    &.size-Size14px {\r\n        @include sized(14px);\r\n        .fi-profile-icon-img {\r\n            width: 14px;\r\n            height: 14px;\r\n            margin: auto;\r\n        }\r\n        .fi-profile-colored {\r\n            font-size: 8px;\r\n            width: 14px;\r\n            height: 14px;\r\n            line-height: 14px;\r\n        }\r\n        .mat-icon {\r\n            height: unset; // for fixing clipped from bottom icon\r\n        }\r\n    }\r\n\r\n    &.size-Size18px {\r\n        @include sized(18px);\r\n        line-height: 19px;\r\n\r\n        .fi-profile-icon-img {\r\n            vertical-align: middle;\r\n        }\r\n        .fi-profile-icon-icon {\r\n            font-size: 18px;\r\n            &.mat-icon {\r\n                display: inline-block;\r\n                line-height: 19px;\r\n                overflow: visible !important;\r\n                &::before {\r\n                    width: 18px;\r\n                    height: 18px;\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n        .fi-profile-colored {\r\n            font-size: 10px;\r\n            width: 18px;\r\n            height: 18px;\r\n            line-height: 19px;\r\n        }\r\n    }\r\n\r\n    &.size-Size20px {\r\n        @include sized(20px);\r\n        .fi-online-badge {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    &.size-Size18px,\r\n    &.size-Size24px,\r\n    &.size-Size28px {\r\n        .fi-online-badge {\r\n            width: 8px;\r\n            height: 8px;\r\n            bottom: 0;\r\n            right: 0;\r\n            border-width: 1px;\r\n        }\r\n    }\r\n\r\n    &.size-Size24px {\r\n        @include sized(24px);\r\n        .fi-profile-icon-icon {\r\n            font-size: 1.3em;\r\n        }\r\n        .fi-profile-colored {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n    &.size-Size28px {\r\n        @include sized(28px);\r\n        line-height: 28px;\r\n        .fi-profile-icon-icon {\r\n            font-size: 1.3em;\r\n            &.mat-icon {\r\n                font-size: 28px;\r\n                display: inline-block;\r\n                line-height: 28px;\r\n                overflow: visible !important;\r\n                &::before {\r\n                    width: 28px;\r\n                    height: 28px;\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n        .fi-profile-colored {\r\n            font-size: 14px;\r\n        }\r\n    }\r\n\r\n    &.size-Size32px {\r\n        @include sized(32px);\r\n        line-height: 32px;\r\n        .fi-profile-icon-icon {\r\n            font-size: 32px;\r\n            &.mat-icon {\r\n                display: inline-block;\r\n                line-height: 32px;\r\n                overflow: visible !important;\r\n                &::before {\r\n                    width: 32px;\r\n                    height: 32px;\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n\r\n        .fi-online-badge {\r\n            width: 10px;\r\n            height: 10px;\r\n            bottom: 0;\r\n            right: 0;\r\n        }\r\n    }\r\n\r\n    &.size-Size40px {\r\n        @include sized(40px);\r\n\r\n        .fi-online-badge {\r\n            width: 12px;\r\n            height: 12px;\r\n            bottom: 0;\r\n            right: 0;\r\n        }\r\n        .fi-profile-icon-icon {\r\n            &.mat-icon {\r\n                font-size: 40px;\r\n                display: inline-block;\r\n                line-height: 40px;\r\n                overflow: visible !important;\r\n                text-align: center;\r\n                transform: translateX(1px);\r\n            }\r\n        }\r\n    }\r\n\r\n    &.size-Size50px {\r\n        @include sized(50px);\r\n        .fi-profile-icon-icon {\r\n            font-size: 3.2em;\r\n        }\r\n\r\n        .fi-online-badge {\r\n            bottom: 2px;\r\n            right: 0;\r\n            width: 15px;\r\n            height: 15px;\r\n        }\r\n    }\r\n\r\n    &.size-Size64px {\r\n        @include sized(64px);\r\n        .fi-profile-icon-icon {\r\n            font-size: 64px;\r\n        }\r\n        .fi-profile-colored {\r\n            font-size: 32px;\r\n        }\r\n        .fi-online-badge {\r\n            bottom: 2px;\r\n            right: 0;\r\n            width: 15px;\r\n            height: 15px;\r\n        }\r\n    }\r\n\r\n    &.size-Size150px {\r\n        @include sized(150px);\r\n        font-size: 5.2em;\r\n\r\n        .fi-online-badge {\r\n            bottom: 5px;\r\n            right: 25px;\r\n            width: 16px;\r\n            height: 16px;\r\n        }\r\n    }\r\n\r\n    &.size-Size130px {\r\n        @include sized(130px);\r\n        font-size: 4.2em;\r\n\r\n        .fi-online-badge {\r\n            bottom: 0px;\r\n            right: 25px;\r\n            width: 16px;\r\n            height: 16px;\r\n        }\r\n    }\r\n\r\n    .fi-online-badge {\r\n        background-color: var(--fi-color-green);\r\n        border: 2px solid var(--fi-color-white);\r\n        position: absolute;\r\n        border-radius: 50%;\r\n    }\r\n}\r\n\r\n.mat-mdc-option {\r\n    .mdc-list-item__primary-text {\r\n        .fi-profile-icon.size-Size32px {\r\n            .fi-profile-icon-icon {\r\n                font-size: 28px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
